import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { FaqItem, Faq as Faq$1 } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/state';
import { parseBloomreachContent } from '../../hooks/helpers/helpers.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsFaqItem = withEditableContent(({ content  })=>{
    const { name , question , answer  } = content;
    return /*#__PURE__*/ React.createElement(FaqItem, {
        id: name,
        question: question,
        answer: answer.value
    });
});
const CmsFaq = ({ page , content: content1  })=>{
    const { name , title , faqItems  } = content1;
    var ref;
    const items = (ref = faqItems === null || faqItems === void 0 ? void 0 : faqItems.map((item)=>{
        const document = page === null || page === void 0 ? void 0 : page.getContent(item);
        const content = parseBloomreachContent(document === null || document === void 0 ? void 0 : document.getData());
        return swcHelpers.objectSpread({}, content, {
            document
        });
    })) !== null && ref !== void 0 ? ref : [];
    var ref1;
    const ids = items.map((item)=>{
        return (ref1 = item === null || item === void 0 ? void 0 : item.name) !== null && ref1 !== void 0 ? ref1 : '';
    });
    return /*#__PURE__*/ React.createElement(Faq$1, {
        name: name,
        title: title,
        ids: ids
    }, items.map((item, i)=>item && /*#__PURE__*/ React.createElement(CmsFaqItem, {
            key: `${i}-${item.id}`,
            content: item
        })
    ));
};
var Faq = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CmsFaq);

export { CmsFaq, CmsFaqItem, Faq as default };
//# sourceMappingURL=Faq.js.map
